import React, { useState } from 'react';
import { Box, Typography, Button, Divider, FormControl, Select, MenuItem, Snackbar } from '@mui/material';
import Navbar from '../Layouts/Navbar';
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Close, Edit } from '@mui/icons-material';
import MuiAlert from '@mui/material/Alert';

export default function EditReservation() {
  const [formData, setFormData] = useState({
    heure: '',
    trajet: '',
    pickup: '',
    dropoff: '',
  });
  const [snack, setSnack] = useState({
    open: false,
    message: '',
    type: '',
  });

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Snackbar handler
  const handleSnack = (message, type) => {
    setSnack({ open: true, message, type });
  };

  // Close Snackbar
  const handleCloseSnack = () => {
    setSnack({ ...snack, open: false });
  };

  // Modify handler
  const handleModify = () => {
    try {
      // Modify logic would go here
      handleSnack('Réservation modifiée avec succès', 'success');
    } catch (error) {
      handleSnack("Erreur lors de la modification de la réservation", 'error');
    }
  };

  return (
    <>
      <Navbar />
      <Box p={3}>
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Box display="flex" alignItems="center">
            <CalendarMonthIcon />
            <Typography variant="h6" ml={1}> EDITER UNE RÉSERVATION</Typography>
          </Box>
        </Box>

        {/* Data Section */}
        <Box flex={1} pr={2}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'start' }}>
            <Typography variant="subtitle2" sx={{ fontSize: '17px' }}>Heure</Typography>
            <FormControl fullWidth size="small" sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' },
                  }
                }}>
              <Select 
                name="heure" 
                value={formData.heure} 
                onChange={handleChange}
                
              >
                <MenuItem value="14:00">14:00</MenuItem>
                <MenuItem value="15:00">15:00</MenuItem>
                <MenuItem value="16:00">16:00</MenuItem>
              </Select>
            </FormControl>

            <Typography variant="subtitle2" sx={{ mt: 1, fontSize: '17px' }}>Trajet</Typography>
            <FormControl fullWidth size="small" sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' },
                  }
                }}>
              <Select 
                name="trajet" 
                value={formData.trajet} 
                onChange={handleChange}
                
              >
                <MenuItem value="Ville A - Ville B">Ville A - Ville B</MenuItem>
                <MenuItem value="Ville B - Ville C">Ville B - Ville C</MenuItem>
                <MenuItem value="Ville A - Ville C">Ville A - Ville C</MenuItem>
              </Select>
            </FormControl>

            <Typography variant="subtitle2" sx={{ mt: 1, fontSize: '17px' }}>Point de ramassage</Typography>
            <FormControl fullWidth size="small" sx={{
                  '& .MuiOutlinedInput-root': {
                    '&:hover fieldset': { borderColor: '#000' },
                    '&.Mui-focused fieldset': { borderColor: 'red' },
                  }
                }}>
              <Select 
                name="pickup" 
                value={formData.pickup} 
                onChange={handleChange}
                
              >
                <MenuItem value="Adresse A">Adresse A</MenuItem>
                <MenuItem value="Adresse B">Adresse B</MenuItem>
                <MenuItem value="Adresse C">Adresse C</MenuItem>
              </Select>
            </FormControl>
          </Box>
          <Divider sx={{ mt: 2, mb: 2, borderColor: "red", borderWidth: "1px" }} />
          <Box display="flex" gap={2}>
            <Button
              variant="outlined"
              sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}
              startIcon={<Close />}
            >
              Annuler
            </Button>
            <Button
              variant="outlined"
              sx={{
                color: 'red',
                borderColor: 'red',
                textTransform: 'none',
                '&:hover': { backgroundColor: 'red', color: '#fff', borderColor: 'red' },
              }}
              startIcon={<Edit />}
              onClick={handleModify}
            >
              Enregistrer
            </Button>
          </Box>
        </Box>
      </Box>

      {/* Snackbar */}
      <Snackbar 
        open={snack.open} 
        autoHideDuration={3000} 
        onClose={handleCloseSnack} 
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MuiAlert 
          onClose={handleCloseSnack} 
          severity={snack.type} 
          elevation={6} 
          variant="filled" 
          sx={{ width: '100%', bgcolor: snack.type === 'success' ? 'green' : 'red' }}
        >
          {snack.message}
        </MuiAlert>
      </Snackbar>
    </>
  );
}
